import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-caste-category',
  templateUrl: './caste-category.component.html',
  styleUrls: ['./caste-category.component.css']
})
export class CasteCategoryComponent implements OnInit {
  myForm: FormGroup;
  table: Array<any> = [];
  isEdit: boolean = false;
  labelName: any = {};
  headingName: any = {};
  workItemId: any;
  editData: any;
  casteId: any;
  caste: Array<any> = [];
  constructor(private toastr: ToastrService, private active: ActivatedRoute, private fb: FormBuilder, private CommonService: CommonService) {
    this.active.params.subscribe(res => {
      this.workItemId = res.id
    })
    this.loadlabels();
    this.loadHeadings();
    this.load();
    this.casteDropdown();
  }

  ngOnInit(): void {
    this.myForm = this.fb.group({
      caste_id: ['',Validators.required],
      category_name: ['',Validators.required],
      category_description: ['',Validators.required],
      status:['',Validators.required]

    })
  }
  loadlabels() {
    this.labelName = {};
    this.CommonService.getCall(`TenantRegistration/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.labelName = res;
      console.log(res);
    })
  }

  loadHeadings() {
    this.headingName = {};
    this.CommonService.getCall(`EmsDynamicheadingLables/GetLabelValuesByTaskid/${this.workItemId}/${localStorage.getItem('TenantCode')}`).subscribe((res: any) => {
      this.headingName = res;
    })
  }

  load() {
    this.table = [];
    let payload = {
      "tnt_code": localStorage.getItem('TenantCode')
    }
    this.CommonService.postCall('EmsCasteCategory/GetList', payload).subscribe((res: any) => [
      this.table = res
    ])
  }


  casteDropdown() {
    this.caste = [];
    let payLoad = {
      "tnt_code": localStorage.getItem('TenantCode')
    }
    this.CommonService.postCall('EmsCaste/GetList', payLoad).subscribe((res: any) => {
      this.caste = res;
    })
  }
  add() {
    this.editData = {};
    this.isEdit = false;
    this.myForm.reset();
  }

  onSubmit(form) {
    let value: any = form.value;
    value['tnt_code'] = localStorage.getItem('TenantCode');
    value['created_by'] = localStorage.getItem('UserId');
    value['modified_by'] = localStorage.getItem('UserId');
    if (this.isEdit) {
      value['modified_by'] = localStorage.getItem('UserId');
      value['caste_category_id'] = this.casteId;
      this.CommonService.postCall('EmsCasteCategory/Update', value).subscribe((res: any) => {
        this.load();
        this.toastr.success("Caste Category Updated Successfully");
        document.getElementById('md_close').click();
      }, err => {
        this.toastr.error(err.error ? err.error : 'Caste Category Not Updated')
      })
    } else {
      this.CommonService.postCall('EmsCasteCategory/Create', value).subscribe((res: any) => {
        this.load();
        this.toastr.success("Caste Category Created Successfully");
        document.getElementById('md_close').click();
      }, err => {
        this.toastr.error(err.error ? err.error : 'Caste Category Not created')
      })

    }
  }

  edit(cId: any) {
    this.casteId = cId;
    console.log(cId);
    this.isEdit = true;
    let payLoad = {
      "caste_category_id": cId
    }
    this.CommonService.postCall('EmsCasteCategory/Get', payLoad).subscribe((res: any) => {
      this.editData = res;
      setTimeout(() => {
        this.dataTransfer(res);
      }, 10);
    })
  }
  dataTransfer(data) {
    this.myForm.patchValue({
      caste_id: data['caste_id'],
      category_name:data['category_name'],
      category_description:data['category_description'],
      status: data['status'],
    })
  }
  close() {

  }
}
